/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < codebhendi, Ravi Ranjan Kumar,  Mylavarapu Sarath Sai, Sanket, Amal Sabu, Ujjwal Singh >

*/
import { client, syncClient, timezone } from "./";
import axios from "axios";
import { syncBaseUrl } from "database/onlineDb/baseUrl";
import {
  getPatients,
  getPatientDetailById,
  deletePatient,
  savePatient,
  updatePatient,
  updateViewPatient,
} from "database/offlineDb/indexDb";
import {
  getAuthTokenFromSessionStorage,
  stripInlineBase64FromWire,
} from "helpers/common";

export { stripRetinalImageBase64FromWire } from "helpers/common";

export function syncPatientDataWithServer(data) {
  return function (dispatch) {
    syncClient
      .post("/patient", data, {
        headers: {
          Accept: "*/*",
          authorization: getAuthTokenFromSessionStorage(),
        },
      })
      .then((response) => {
        dispatch({
          type: "SYNC_PATIENT_DATA",
          payload: response,
        });
      });
  };
  // let response=dispatch({
  //     type: 'SYNC_PATIENT_DATA',
  //     payload:syncClient.post(`/patient`,data,
  //     {
  //         headers:{
  //           "Accept":"*/*",
  //           "authorization":getAuthTokenFromSessionStorage()
  //         },
  //     }
  //     )
  // })
  // return response
}
export const saveOrUpdatePatientData = (data) => (dispatch) => {
  let response = dispatch({
    type: "ADD_PATIENT_DATA_FULFILLED",
    payload: savePatient(data),
  });
  // console.log('response',response)
  return response;
  // return function (dispatch) {
  //     savePatient(data)
  //         .then((response) => {
  //             dispatch({
  //                 type: 'ADD_PATIENT_DATA_FULFILLED',
  //                 payload: response
  //             })
  //         })
  // }
};
export const updatePatientData = (data, origin) => async (dispatch) => {
  // console.log("updatePatienthero", data);
  // await updateViewPatient(data);

  let patient = data;
  let updatedData = {
    mrn: patient.mrn,
    fname: patient.registrationData.basicDetails.firstName,
    mname: patient.registrationData.basicDetails.middleName,
    lname: patient.registrationData.basicDetails.lastName,
    email: patient.registrationData.basicDetails.email,
    gender: patient.registrationData.basicDetails.gender,
    // Changed our product to use age instead of dob.
    // dob: patient.registrationData.basicDetails.dob,
    age: patient.registrationData.basicDetails.age,
    hp_id: patient.registrationData.basicDetails.hp_id,
  };
  let finalData = {
    data: stripInlineBase64FromWire(data),
    updatedData,
  };
  // console.log("updatedData", updatedData);

  axios({
    method: "put",
    url: syncBaseUrl + "/patient/" + patient.mrn,
    data: finalData,
    headers: {
      Accept: "*/*",
      authorization: getAuthTokenFromSessionStorage(),
    },
  }).then((res) => {
    // console.log("updatekebad", res);
    // let data = {
    //   mrn: patient.mrn,
    //   updatedBasicDetailOnServer: true,
    //   basicDetailOnServer: true,
    // };
    updateViewPatient(data).then((res) => {
      // props.getPatientsList();
    });
  });
  // console.log("updateaction", data);
  if (origin !== "viewPatient") {
    let response = dispatch({
      type: "ADD_PATIENT_DATA_FULFILLED",
      payload: updatePatient(data),
    });
    return response;
  }
  // return function (dispatch) {
  //     updatePatient(data)
  //         .then((response) => {
  //             dispatch({
  //                 type: 'ADD_PATIENT_DATA_FULFILLED',
  //                 payload: response
  //             })
  //         })
  // }
};
//get patient detail with id

export function getPatientDataById(id) {
  // console.log('id',typeof(id))
  return function (dispatch) {
    return getPatientDetailById(id).then((response) => {
      dispatch({
        type: "GET_PATIENT_DATA_BY_ID_FULFILLED",
        payload: response,
      });
    });
  };
}
const currentRealtimeScope = (scope) => {
  try {
    return typeof scope?.isCurrent !== "function" || scope.isCurrent();
  } catch (error) {
    return false;
  }
};

export function getPatientsList(scope = {}) {
  return function (dispatch) {
    if (!currentRealtimeScope(scope)) {
      return Promise.resolve({ outcome: "ignored" });
    }
    return getPatients().then((response) => {
      if (!currentRealtimeScope(scope)) return { outcome: "ignored" };
      return dispatch({
        type: "GET_PATIENTS_LIST_FULFILLED",
        payload: response,
      });
    });
  };
}

export function getPatientsListByServer() {
  return function (dispatch) {
    syncClient
      .get("/patient", {
        headers: {
          Accept: "*/*",
          authorization: getAuthTokenFromSessionStorage(),
        },
      })
      .then((response) => {
        dispatch({
          type: "GET_PATIENTS_LIST_FULFILLED",
          payload: response,
        });
      });
  };
}
// -----for store-----
export function createPatientFormData(field, value) {
  return (dispatch) => {
    dispatch({
      type: "CREATE_PATIEN_FORMDATA_FULFILLED",
      payload: { field, value },
    });
  };
}
export function saceOrUpdateBtn(saveOrUpdate) {
  // console.log("saveOrUpdateBtn", saveOrUpdate);
  return (dispatch) => {
    dispatch({
      type: "SAVE_OR_UPDATE_PATIENT_BTN_FULFILLED",
      payload: saveOrUpdate,
    });
  };
}
export function isRegisteredResponse(payload) {
  const { message, error } = payload;
  return (dispatch) => {
    dispatch({
      type: "IS_REGISTERED_RESPONSE_FULFILLED",
      payload: { message, error },
    });
  };
}

export function selectedPatientListData(value) {
  return (dispatch) => {
    dispatch({
      type: "SELECTED_PATIENT_LIST_DATA",
      payload: value,
    });
  };
}
// add patient stores
export function createBasicDetailsFormData(field, value) {
  return (dispatch) => {
    dispatch({
      type: "CREATE_BASIC_DETAILS_FORMDATA_FULFILLED",
      payload: { field, value },
    });
  };
}
export function createSymtomsFormData(field, value) {
  return (dispatch) => {
    dispatch({
      type: "CREATE_SYMTOMS_FORMDATA_FULFILLED",
      payload: { field, value },
    });
  };
}
export function createPersonalDetailsStatsFormData(field, value) {
  return (dispatch) => {
    dispatch({
      type: "CREATE_PERSONAL_DETAILS_STATS_FORMDATA__FULFILLED",
      payload: { field, value },
    });
  };
}
export function createPersonalDetailsContactsFormData(field, value) {
  return (dispatch) => {
    dispatch({
      type: "CREATE_PERSONAL_DETAILS_CONTACTS_FORMDATA_FULFILLED",
      payload: { field, value },
    });
  };
}
export function createPatientMedicalHistoryFormData(field, value) {
  return (dispatch) => {
    dispatch({
      type: "CREATE_PATIENT_MEDICAL_HISTORY_FORMDATA_FULFILLED",
      payload: { field, value },
    });
  };
}
export function createFamilyMedicalHistoryFormData(field, value) {
  // console.log("payload", value);
  return (dispatch) => {
    dispatch({
      type: "CREATE_FAMILY_MEDICAL_HISTORY_FORMDATA_FULFILLED",
      payload: { field, value },
    });
  };
}
export function createBloodGlucoseFormData(field, value) {
  return (dispatch) => {
    dispatch({
      type: "CREATE_BLOOD_GLUCOSE_FORMDATA_FULFILLED",
      payload: { field, value },
    });
  };
}
export function createBloodPressureFormData(field, value) {
  return (dispatch) => {
    dispatch({
      type: "CREATE_BLOOD_PRESSURE_FORMDATA_FULFILLED",
      payload: { field, value },
    });
  };
}
export function createGenBloodTestFormData(field, value) {
  return (dispatch) => {
    dispatch({
      type: "CREATE_GEN_BLOOD_TEST_FORMDATA_FULFILLED",
      payload: { field, value },
    });
  };
}
export function createLipidProfileFormData(field, value) {
  return (dispatch) => {
    dispatch({
      type: "CREATE_LIPID_PROFILE_FORMDATA_FULFILLED",
      payload: { field, value },
    });
  };
}
export function createRenalFunctionFormData(field, value) {
  return (dispatch) => {
    dispatch({
      type: "CREATE_RENAL_FUNCTION_FORMDATA_FULFILLED",
      payload: { field, value },
    });
  };
}
export function createLifeStyleFormData(field, value) {
  return (dispatch) => {
    dispatch({
      type: "CREATE_LIFE_STYLE_FORMDATA_FULFILLED",
      payload: { field, value },
    });
  };
}
export function createRetinalImagesFormData(field, value) {
  return (dispatch) => {
    dispatch({
      type: "CREATE_RETINAL_IMAGES_FORMDATA_FULFILLED",
      payload: { field, value },
    });
  };
}
export function updatePatientList(value) {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_PATIENT_LIST",
      payload: value,
    });
  };
}
export function updateCreatePatientFormData(data) {
  // console.log("datata", data);
  if (data !== undefined) {
    return (dispatch) => {
      dispatch({
        type: "UPDATE_CREATE_PATIENT_FORMDATA_FULFILLED",
        payload: data,
      });
    };
  } else {
    return (dispatch) => {
      dispatch({
        type: "ADD_CREATE_PATIENT_FORMDATA_FULFILLED",
        payload: data,
      });
    };
  }
}

export const deleteBulkPatients = (array) => (dispatch) => {
  const data = { mrnArray: array };

  return client
    .post("/updatePatient", data, {
      headers: {
        Accept: "*/*",
        authorization: getAuthTokenFromSessionStorage(),
        // orgz_id,
        //  enddate: endDate,
        //  orgz_id,
      },
    })
    .then(async (res) => {
      for (let i = 0; i < array.length; i++) {
        await deletePatient(array[i]);
      }
      return "deleted";
    })
    .catch((err) => {
      console.log("deleteBulkPatients err", err);
    });
};

export function triggerPatientReportCountAlert(payload) {
  return {
    type: "TRIGGER_PATIENT_REPORT_COUNT_ALERT",
    payload,
  };
}

export function updatePatientDataById(payload) {
  return {
    type: "UPDATE_PATIENT_DATA_BY_ID",
    payload,
  };
}

export function setActivePatientRealtimeMrn(payload) {
  return {
    type: "SET_ACTIVE_PATIENT_REALTIME_MRN",
    payload: payload === undefined ? null : payload,
  };
}

export function setPendingPatientRealtimeMrn(payload) {
  return {
    type: "SET_PENDING_PATIENT_REALTIME_MRN",
    payload: payload === undefined ? null : payload,
  };
}

export const activatePatientRealtimeAfterList = (mrn) => async (dispatch) => {
  dispatch(setPendingPatientRealtimeMrn(mrn));
  try {
    await dispatch(getPatientsList());
    return dispatch(setActivePatientRealtimeMrn(mrn));
  } catch (error) {
    dispatch(setPendingPatientRealtimeMrn(null));
    throw error;
  }
};
